<template>
    <el-dialog width="40%" title="位置信息" :visible.sync="viewDetail" @close="closeModel">
        <el-row type="flex" align="middle">
            <el-col :span="4"> 地理位置 ： </el-col>
            <el-col :span="16">
                <el-autocomplete v-model="mapLocation.address" :fetch-suggestions="querySearch" placeholder="请输入详细地址" style="width: 100%" :trigger-on-focus="false" @select="handleSelect" />
            </el-col>
            <el-col :span="4">
                <el-button type="primary" @click="handleButton" :loading="loading">保存 </el-button>
            </el-col>
        </el-row>
        <div class="maindiv" v-if="data_list">
            <baidu-map class="bm-view" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom="true" @ready="handlerBMap" />
        </div>
    </el-dialog>
</template>

<script>
import { setgeo } from "@/api/erweima/index";
export default {
    props: {
        details_id: {
            require: true,
        },
        data_list: {
            require: true,
        },
    },
    data() {
        return {
            viewDetail: true,
            locationname: "",
            loading: false,
            infoWindow: {
                show: false,
                info: {
                    lng: "",
                    lat: "",
                },
            },
            mapZoom: 15,
            mapCenter: { lng: 0, lat: 0 },
            mapLocation: {
                address: undefined,
                coordinate: undefined,
            },
            zoom: 3,
        };
    },
    mounted() {},
    methods: {
        closeModel() {
            this.$emit("closeModel");
        },
        handleButton() {
            if (this.mapLocation.address == "") {
                this.$message.error({ message: "请输入地址" });
            } else {
                this.setgeo_();
            }
        },
        setgeo_() {
            this.loading = true;
            let par = {
                id: this.details_id,
                lat: this.mapCenter.lat,
                lng: this.mapCenter.lng,
            };
            setgeo(par)
                .then((res) => {
                    this.loading = false;
                    if (res.code == 1) {
                        this.$message.error({ message: "保存成功" });
                        this.closeModel();
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },

        handlerBMap({ BMap, map }) {
            this.BMap = BMap;
            this.map = map;
            var geoc = new BMap.Geocoder();
            this.mapCenter.lng = this.data_list.lng;
            this.mapCenter.lat = this.data_list.lat;
            var imgsrc = require("../../../../assets/icon/mapIcon.png");
            var pt = new BMap.Point(this.data_list.lng, this.data_list.lat);
            var myIcon = new BMap.Icon(imgsrc, new BMap.Size(100, 100));
            var marker = new BMap.Marker(pt, { icon: myIcon }); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            //alert(e.point.lng + "," + e.point.lat);
            var addComp = "";
            geoc.getLocation(pt, function (rs) {
                addComp = rs.address;
                console.log(addComp);
            });
            var content = "<table>";
            content = content + `<tr><td> 地点：${addComp}</td></tr>`;
            var infowindow = new BMap.InfoWindow(content);
            marker.addEventListener("click", function () {
                this.openInfoWindow(infowindow);
            });

            if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
                this.mapCenter.lng = this.mapLocation.coordinate.lng;
                this.mapCenter.lat = this.mapLocation.coordinate.lat;
                this.mapZoom = 15;
                map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
            }
            /* else {
        this.mapCenter.lng =this.data_list.lng
        this.mapCenter.lat =this.data_list.lat
        this.mapZoom = 10
      } */
        },
        querySearch(queryString, cb) {
            var that = this;
            var myGeo = new this.BMap.Geocoder();
            myGeo.getPoint(
                queryString,
                function (point) {
                    if (point) {
                        that.mapLocation.coordinate = point;
                        that.makerCenter(point);
                    } else {
                        that.mapLocation.coordinate = null;
                    }
                },
                this.locationCity
            );
            var options = {
                onSearchComplete: function (results) {
                    if (local.getStatus() === 0) {
                        // 判断状态是否正确
                        var s = [];
                        for (var i = 0; i < results.getCurrentNumPois(); i++) {
                            var x = results.getPoi(i);
                            var item = { value: x.address + x.title, point: x.point };
                            s.push(item);
                            cb(s);
                        }
                    } else {
                        cb();
                    }
                },
            };
            var local = new this.BMap.LocalSearch(this.map, options);
            local.search(queryString);
        },
        handleSelect(item) {
            var { point } = item;
            this.mapLocation.coordinate = point;
            this.makerCenter(point);
        },
        makerCenter(point) {
            if (this.map) {
                this.map.clearOverlays();
                this.map.addOverlay(new this.BMap.Marker(point));
                this.mapCenter.lng = point.lng;
                this.mapCenter.lat = point.lat;
                this.mapZoom = 15;
            }
        },
    },
    components: {},
};
</script>

<style scoped lang="scss">
.maindiv {
    overflow: hidden;
    box-sizing: border-box;
    margin-top: 10px;
    padding: 10px 10px 40px 10px;
    width: 100%;
    //height: 400px;
}
.bm-view {
    height: 400px;
}

/*  BMap_cpyCtrl BMap_noprint anchorBL */
</style>
